import { asRoleKey } from '../../../access';
import type { RoleKeySet, RoleTemplateSummary } from '../types/domain.types';

import { USER_CENTER_ENDPOINTS } from './endpoints';
import { request } from './http';
import { parseOrThrow, permissionTemplatesSchema, templatesSchema } from './schemas';

export const fetchRoleTemplates = async (signal?: AbortSignal): Promise<RoleTemplateSummary[]> => {
  const raw = await request('get', USER_CENTER_ENDPOINTS.TEMPLATES, { signal });
  const dto = parseOrThrow(templatesSchema, raw, 'role templates');
  return dto.templates.map((t) => ({ ...t, roleKey: asRoleKey(t.roleKey) }));
};

export const fetchPermissionTemplates = async (signal?: AbortSignal): Promise<RoleKeySet[]> => {
  const raw = await request('get', USER_CENTER_ENDPOINTS.PERMISSION_TEMPLATES, { signal });
  return parseOrThrow(permissionTemplatesSchema, raw, 'permission templates').roles;
};
